import React from 'react';
import ChartTableComponent from '../../components/Chart/ChartTable';

/*
props: {
    chartData: All the data for the charts.
    windowHeight: Indicates what is the maximum height that the table can have.                                       
    updateTableDataChartView: Function to inform chartView of the data displayed in the table, to export it.
}

*/

class ChartTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
            tableHeader: [],
            tableRows: []
		};
	}

    // Each row of the table is generated element by element. And they are displayed in the order they are generated.
    // To prevent warnings each cell in a row has its own key.
    convertChartToTable(){
        const xtitle = this.props.chartData.xtitle;
        const legendData = this.props.chartData.legendData;
        const data = this.props.chartData.data;
        const title = this.props.chartData.title;
        var tableHeader = [];
        var tableRows = [];
        var row = [];
        var i;
        var j;
        // this variables are to store and send the table data to chartView to export it as a csv.
        // its done separtly because the export function needs an array of values and not an array of jsons.
        var tableHeaderChartView = [];
        var rowChartView = [];
        var tableRowsChartView = [];
        var tableTitle = [];
        tableHeader.push({
            name: xtitle,
            key: -1
        });
        tableHeaderChartView.push(xtitle);
        tableTitle.push(title);
        for(i = 0; i < legendData.length; i++){
            tableHeader.push({
                name: legendData[i].name,
                key: i
            });
            tableHeaderChartView.push(legendData[i].name);
            tableTitle.push("");
        }
        for(i = 0; i < data.length; i++){
            row.push({
                name: data[i]["xaxi"],
                key: 0
            });
            rowChartView.push(data[i]["xaxi"]);
            for(j = 1; j < tableHeader.length; j++){
                row.push({
                    name: data[i][tableHeader[j].name],
                    key: j
                });
                rowChartView.push(data[i][tableHeader[j].name]);
            }
            tableRows.push({
                rowData: row,
                key: i
            });
            tableRowsChartView.push(rowChartView);
            row = [];
            rowChartView = [];
        }

        this.props.updateTableDataChartView(tableTitle, tableHeaderChartView, tableRowsChartView);

        this.setState({
            tableHeader: tableHeader,
            tableRows: tableRows
        });
    }

    componentDidMount(){
        this.convertChartToTable();
    }

    render() {
        const title = this.props.chartData.title;
        const windowHeight = this.props.windowHeight;
        const {tableHeader, tableRows} = this.state;
		return (
            <ChartTableComponent
                windowHeight={windowHeight}
                title={title}
                tableHeader={tableHeader}
                tableRows={tableRows}
            />
		);
	}
}

export default ChartTable;